
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/warsztaty-produktowe",
      function () {
        return require("private-next-pages/warsztaty-produktowe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/warsztaty-produktowe"])
      });
    }
  